import { GuideMenu, type GuideMenuProps } from '@/components/GuideMenu/GuideMenu'

/** @deprecated use GuideMenu */
export function TOCMobile(props: GuideMenuProps) {
    return <GuideMenu {...props} />
}
